import React from 'react';
import { Box, Grid, IconButton, TextField } from '@mui/material';
import { Delete as DeleteIcon } from '@mui/icons-material';
import {
  formatClienteDisplay,
  PlanVisitaDireccionField,
  SelectBox,
  visitRowTextFieldProps,
  VisitRowState,
} from './planVisitaFormUi';

interface PlanVisitaItemRowProps {
  row: VisitRowState;
  onPatch: (patch: Partial<VisitRowState>) => void;
  onOpenClientePicker: () => void;
  onOpenDireccionPicker: () => void;
  onRemove?: () => void;
}

const PlanVisitaItemRow: React.FC<PlanVisitaItemRowProps> = ({
  row,
  onPatch,
  onOpenClientePicker,
  onOpenDireccionPicker,
  onRemove,
}) => (
  <Box sx={{ p: 1.5, border: '1px solid #e0e0e0', borderRadius: 2 }}>
    <Grid container spacing={1.5} alignItems="flex-start">
      <Grid item xs={12} md={3}>
        <SelectBox
          label="Cliente"
          display={formatClienteDisplay(row)}
          placeholder="Tocá para buscar cliente"
          helperText={
            row.clienteNombre
              ? 'Tocá el campo para cambiar el cliente.'
              : 'Tocá el campo para abrir Buscar Cliente.'
          }
          onOpen={onOpenClientePicker}
        />
      </Grid>
      <Grid item xs={12} md={3}>
        <PlanVisitaDireccionField
          row={row}
          onPatch={onPatch}
          onOpenDireccionPicker={onOpenDireccionPicker}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={2}>
        <TextField
          {...visitRowTextFieldProps}
          label="Horario preferido"
          placeholder="HH:MM"
          InputLabelProps={{ shrink: true }}
          value={row.horarioPreferido}
          onChange={(e) => onPatch({ horarioPreferido: e.target.value })}
          helperText="Opcional (ej: 09:30)"
        />
      </Grid>
      <Grid item xs={12} sm={6} md={onRemove ? 3 : 4}>
        <TextField
          {...visitRowTextFieldProps}
          label="Obs. visita"
          value={row.observaciones}
          onChange={(e) => onPatch({ observaciones: e.target.value })}
          helperText=" "
        />
      </Grid>
      {onRemove ? (
        <Grid
          item
          xs={12}
          md={1}
          sx={{
            display: 'flex',
            justifyContent: { xs: 'flex-start', md: 'center' },
            pt: { xs: 0, md: 2.75 },
          }}
        >
          <IconButton color="error" size="small" aria-label="Quitar visita" onClick={onRemove}>
            <DeleteIcon />
          </IconButton>
        </Grid>
      ) : null}
    </Grid>
  </Box>
);

export default PlanVisitaItemRow;
